"use strict";
const firebase = require('firebase');
const types_1 = require('./types');
const FIREBASE_ERROR_ACCOUNT_EXISTS = 'auth/account-exists-with-different-credential';
const PENDING_CREDENTIAL_KEY = 'pendingCredential';
class Auth {
    initialize() {
        this.auth = firebase.auth();
        const facebookAuthProvider = new firebase.auth.FacebookAuthProvider();
        facebookAuthProvider.addScope('email');
        const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
        googleAuthProvider.addScope('email');
        const twitterAuthProvider = new firebase.auth.TwitterAuthProvider();
        this.providerMap = {
            'facebook.com': facebookAuthProvider,
            'google.com': googleAuthProvider,
            'twitter.com': twitterAuthProvider,
        };
    }
    onAuthStateChanged(callback) {
        this.auth.onAuthStateChanged(callback);
    }
    signInWithProvider(providerId) {
        // Wrap the firebase call in a promise to handle firebase errors here
        // rather than in calling code.
        return new Promise((resolve, reject) => {
            if (window.localStorage.hasOwnProperty(PENDING_CREDENTIAL_KEY)) {
                this.signInWithPendingCredential(providerId).then(() => resolve(), (error) => reject(new types_1.UncaughtError(error.code)));
                return;
            }
            const provider = this.getProvider(providerId);
            this.auth.signInWithPopup(provider).then(() => resolve(), (error) => {
                switch (error.code) {
                    case FIREBASE_ERROR_ACCOUNT_EXISTS:
                        // User's email already exists. Store credential for linking.
                        const pendingCredential = error.credential;
                        window.localStorage.setItem(PENDING_CREDENTIAL_KEY, JSON.stringify(pendingCredential));
                        // Get registered providers for this email.
                        this.auth.fetchProvidersForEmail(error.email).then(providerIds => {
                            // Recommend the first existing provider.
                            reject(new types_1.AccountExistsError(providerIds[0]));
                        });
                        break;
                    default:
                        reject(new types_1.UncaughtError(error.code));
                }
            });
        });
    }
    cancelLoginAttempt() {
        window.localStorage.removeItem(PENDING_CREDENTIAL_KEY);
    }
    signOut() {
        this.auth.signOut();
    }
    signInWithPendingCredential(providerId) {
        if (!window.localStorage.hasOwnProperty(PENDING_CREDENTIAL_KEY)) {
            return;
        }
        const provider = this.getProvider(providerId);
        const credentialJson = JSON.parse(window.localStorage.getItem(PENDING_CREDENTIAL_KEY));
        window.localStorage.removeItem(PENDING_CREDENTIAL_KEY);
        const credential = this.buildCredential(credentialJson);
        return this.auth.signInWithPopup(provider).then(result => {
            return result.user.link(credential);
        });
    }
    buildCredential(credential) {
        switch (credential.provider) {
            case 'facebook.com':
                return firebase.auth.FacebookAuthProvider.credential(credential.accessToken);
            case 'google.com':
                return firebase.auth.GoogleAuthProvider.credential(credential.accessToken);
            case 'twitter.com':
                return firebase.auth.TwitterAuthProvider.credential(credential.accessToken, credential.secret);
        }
    }
    getProvider(providerId) {
        return this.providerMap[providerId];
    }
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Auth;



/** WEBPACK FOOTER **
 ** ./src/api/auth.ts
 **/